// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/delegations.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { AccountStub, Attachment } from "./common_pb.ts";
import { PhoneCall } from "./conversation_pb.ts";
import { Note } from "./notes_pb.ts";

/**
 * @generated from message protogen.DelegationTask
 */
export class DelegationTask extends Message<DelegationTask> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: string detailsJson = 4;
   */
  detailsJson = "";

  /**
   * @generated from field: string status = 5;
   */
  status = "";

  /**
   * @generated from field: int64 createdSec = 6;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: int64 delegatedSec = 7;
   */
  delegatedSec = protoInt64.zero;

  /**
   * @generated from field: int64 completedSec = 8;
   */
  completedSec = protoInt64.zero;

  /**
   * @generated from field: int32 timeSpentMinutes = 9;
   */
  timeSpentMinutes = 0;

  /**
   * @generated from field: protogen.AccountStub creator = 11;
   */
  creator?: AccountStub;

  /**
   * @generated from field: string agentThreadRef = 12;
   */
  agentThreadRef = "";

  /**
   * @generated from field: string taskRef = 13;
   */
  taskRef = "";

  /**
   * @generated from field: string functionCallId = 14;
   */
  functionCallId = "";

  /**
   * @generated from field: string serviceType = 15;
   */
  serviceType = "";

  /**
   * @generated from field: repeated protogen.DelegationTaskComment comments = 16;
   */
  comments: DelegationTaskComment[] = [];

  /**
   * @generated from field: protogen.AccountStub assignee = 17;
   */
  assignee?: AccountStub;

  /**
   * @generated from field: bool hasUnread = 18;
   */
  hasUnread = false;

  /**
   * @generated from field: string timeEntriesJson = 19;
   */
  timeEntriesJson = "";

  /**
   * @generated from field: int64 actionDateSec = 20;
   */
  actionDateSec = protoInt64.zero;

  /**
   * @generated from field: int32 totalTrackedMinutes = 21;
   */
  totalTrackedMinutes = 0;

  /**
   * @generated from field: int32 timeEstimateMinutes = 22;
   */
  timeEstimateMinutes = 0;

  constructor(data?: PartialMessage<DelegationTask>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DelegationTask";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "detailsJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "delegatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "completedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "timeSpentMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "creator", kind: "message", T: AccountStub },
    { no: 12, name: "agentThreadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "taskRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "functionCallId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "serviceType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "comments", kind: "message", T: DelegationTaskComment, repeated: true },
    { no: 17, name: "assignee", kind: "message", T: AccountStub },
    { no: 18, name: "hasUnread", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "timeEntriesJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "actionDateSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 21, name: "totalTrackedMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 22, name: "timeEstimateMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DelegationTask {
    return new DelegationTask().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DelegationTask {
    return new DelegationTask().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DelegationTask {
    return new DelegationTask().fromJsonString(jsonString, options);
  }

  static equals(a: DelegationTask | PlainMessage<DelegationTask> | undefined, b: DelegationTask | PlainMessage<DelegationTask> | undefined): boolean {
    return proto3.util.equals(DelegationTask, a, b);
  }
}

/**
 * @generated from message protogen.DelegationTaskComment
 */
export class DelegationTaskComment extends Message<DelegationTaskComment> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: protogen.AccountStub author = 2;
   */
  author?: AccountStub;

  /**
   * @generated from field: int64 createdSec = 3;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: string content = 4;
   */
  content = "";

  /**
   * @generated from field: string contentType = 5;
   */
  contentType = "";

  /**
   * @generated from field: string textContent = 6;
   */
  textContent = "";

  /**
   * @generated from field: string updatedStatus = 7;
   */
  updatedStatus = "";

  /**
   * @generated from field: protogen.AccountStub updatedAssignee = 8;
   */
  updatedAssignee?: AccountStub;

  /**
   * @generated from field: bool unassigned = 9;
   */
  unassigned = false;

  /**
   * @generated from field: repeated protogen.Attachment attachments = 10;
   */
  attachments: Attachment[] = [];

  /**
   * @generated from field: protogen.PhoneCall phoneCall = 11;
   */
  phoneCall?: PhoneCall;

  /**
   * @generated from field: protogen.Note callNotes = 12;
   */
  callNotes?: Note;

  /**
   * @generated from field: string recipientType = 13;
   */
  recipientType = "";

  constructor(data?: PartialMessage<DelegationTaskComment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DelegationTaskComment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "author", kind: "message", T: AccountStub },
    { no: 3, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "contentType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "textContent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "updatedStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updatedAssignee", kind: "message", T: AccountStub },
    { no: 9, name: "unassigned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "attachments", kind: "message", T: Attachment, repeated: true },
    { no: 11, name: "phoneCall", kind: "message", T: PhoneCall },
    { no: 12, name: "callNotes", kind: "message", T: Note },
    { no: 13, name: "recipientType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DelegationTaskComment {
    return new DelegationTaskComment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DelegationTaskComment {
    return new DelegationTaskComment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DelegationTaskComment {
    return new DelegationTaskComment().fromJsonString(jsonString, options);
  }

  static equals(a: DelegationTaskComment | PlainMessage<DelegationTaskComment> | undefined, b: DelegationTaskComment | PlainMessage<DelegationTaskComment> | undefined): boolean {
    return proto3.util.equals(DelegationTaskComment, a, b);
  }
}

